import * as Types from '../../../../../../../graphql';

import { gql } from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Mon Sep 22 2025 11:22:40 GMT+0000 (Coordinated Universal Time)
*/

export type EmailCustomizationsPartFragment = { __typename?: 'Email', imageBakeryHashedId?: string | null | undefined, imageUrl?: string | null | undefined };

export const EmailCustomizationsPartFragmentDoc = gql`
    fragment EmailCustomizationsPart on Email {
  imageBakeryHashedId
  imageUrl
}
    `;